var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeleteFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07757 2.67377C6.23385 2.51748 6.44582 2.42969 6.66683 2.42969H9.3335C9.55451 2.42969 9.76647 2.51748 9.92275 2.67377C10.079 2.83005 10.1668 3.04201 10.1668 3.26302V4.09635H5.8335V3.26302C5.8335 3.04201 5.92129 2.83005 6.07757 2.67377ZM11.1668 3.26302V4.09635H12.6668C12.943 4.09635 13.1668 4.32021 13.1668 4.59635V13.9297C13.1668 14.4159 12.9737 14.8822 12.6299 15.2261C12.286 15.5699 11.8197 15.763 11.3335 15.763H4.66683C4.1806 15.763 3.71428 15.5699 3.37047 15.2261C3.02665 14.8822 2.8335 14.4159 2.8335 13.9297V4.59635C2.8335 4.32021 3.05735 4.09635 3.3335 4.09635H4.8335V3.26302C4.8335 2.77679 5.02665 2.31047 5.37047 1.96666C5.71428 1.62284 6.1806 1.42969 6.66683 1.42969H9.3335C9.81973 1.42969 10.286 1.62284 10.6299 1.96666C10.9737 2.31047 11.1668 2.77679 11.1668 3.26302Z",
    fill: "#FF5500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4.59619C1.5 4.32005 1.72386 4.09619 2 4.09619H14C14.2761 4.09619 14.5 4.32005 14.5 4.59619C14.5 4.87233 14.2761 5.09619 14 5.09619H2C1.72386 5.09619 1.5 4.87233 1.5 4.59619Z",
    fill: "#FF5500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 7.42944C6.94265 7.42944 7.1665 7.6533 7.1665 7.92944V11.9294C7.1665 12.2056 6.94265 12.4294 6.6665 12.4294C6.39036 12.4294 6.1665 12.2056 6.1665 11.9294V7.92944C6.1665 7.6533 6.39036 7.42944 6.6665 7.42944Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 7.42944C9.60964 7.42944 9.8335 7.6533 9.8335 7.92944V11.9294C9.8335 12.2056 9.60964 12.4294 9.3335 12.4294C9.05735 12.4294 8.8335 12.2056 8.8335 11.9294V7.92944C8.8335 7.6533 9.05735 7.42944 9.3335 7.42944Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/delete_filled.92d69bfe.svg";
export { ForwardRef as ReactComponent };